import type { ChakraProviderProps } from '@chakra-ui/provider';
import { ChakraProvider } from '@chakra-ui/react';
import { Global } from '@emotion/react';
import { theme } from '../theme';

export const SafeProvider = ({
  theme: themeProp = theme,
  children,
  ...props
}: ChakraProviderProps) => {
  const {
    config: { fontsPath },
  } = themeProp;

  return (
    <ChakraProvider theme={themeProp} {...props}>
      <Fonts path={fontsPath} />
      {children}
    </ChakraProvider>
  );
};

interface FontsProps {
  path: string;
}

const Fonts = ({ path }: FontsProps) => (
  <Global
    styles={`
      @font-face {
        font-family: 'Equip';
        src: url('${path}/Equip-Light.woff2') format('woff2'),
          url('${path}/Equip-Light.woff') format('woff');
        font-weight: 300;
        font-display: swap;
      }

      @font-face {
        font-family: 'Equip';
        src: url('${path}/Equip-LightItalic.woff2') format('woff2'),
          url('${path}/Equip-LightItalic.woff') format('woff');
        font-weight: 300;
        font-style: italic;
        font-display: swap;
      }

      @font-face {
        font-family: 'Equip';
        src: url('${path}/Equip-Regular.woff2') format('woff2'),
          url('${path}/Equip-Regular.woff') format('woff');
        font-weight: 500;
        font-display: swap;
      }

      @font-face {
        font-family: 'Equip';
        src: url('${path}/Equip-Italic.woff2') format('woff2'),
          url('${path}/Equip-Italic.woff') format('woff');
        font-weight: 500;
        font-style: italic;
        font-display: swap;
      }

      @font-face {
        font-family: 'Equip';
        src: url('${path}/Equip-Medium.woff2') format('woff2'),
          url('${path}/Equip-Medium.woff') format('woff');
        font-weight: 600;
        font-display: swap;
      }

      @font-face {
        font-family: 'Equip';
        src: url('${path}/Equip-MediumItalic.woff2') format('woff2'),
          url('${path}/Equip-MediumItalic.woff') format('woff');
        font-weight: 600;
        font-style: italic;
        font-display: swap;
      }

      @font-face {
        font-family: 'Equip';
        src: url('${path}/Equip-Bold.woff2') format('woff2'),
          url('${path}/Equip-Bold.woff') format('woff');
        font-weight: 700;
        font-display: swap;
      }

      @font-face {
        font-family: 'Equip';
        src: url('${path}/Equip-BoldItalic.woff2') format('woff2'),
          url('${path}/Equip-BoldItalic.woff') format('woff');
        font-weight: 700;
        font-style: italic;
        font-display: swap;
      }
    `}
  />
);
